export const config = {
    apiUrl : "https://pokeapi.co/api/v2/pokemon/"
}